import type * as Monaco from 'monaco-editor';

export const CODE_EDITOR_THEME = 'triggerbee';
export const CODE_FONT_FAMILY = "ui-monospace, SFMono-Regular, Menlo, Consolas, 'Liberation Mono', monospace";

const TOKEN_COLORS: Array<[token: string, variable: string]> = [
  ['comment', '--codeComment'],
  ['keyword', '--codeKeyword'],
  ['string', '--codeString'],
  ['attribute.value', '--codeString'],
  ['tag', '--codeTag'],
  ['metatag', '--codeTag'],
  ['attribute.name', '--codeAttribute'],
  ['number', '--codeAttribute'],
  ['type', '--codeTitle'],
];

export function applyCodeEditorTheme(host: HTMLElement, isDark: boolean): void {
  const monaco = (window as unknown as { monaco?: typeof Monaco }).monaco;
  if (!monaco) {
    return;
  }
  const color = (variable: string) => resolveColor(host, variable);
  const background = color('--appBg');
  const foreground = color('--textColor');
  monaco.editor.defineTheme(CODE_EDITOR_THEME, {
    base: isDark ? 'vs-dark' : 'vs',
    inherit: true,
    rules: TOKEN_COLORS.map(([token, variable]) => ({ token, foreground: color(variable).slice(1) })),
    colors: {
      'editor.background': background,
      'editor.foreground': foreground,
      'editorGutter.background': background,
      'editorLineNumber.foreground': color('--grayToGray'),
      'editorLineNumber.activeForeground': foreground,
      'editorCursor.foreground': foreground,
      'editorWidget.background': color('--bgCard'),
    },
  });
  monaco.editor.setTheme(CODE_EDITOR_THEME);
}

function resolveColor(host: HTMLElement, variable: string): string {
  const probe = host.ownerDocument.createElement('span');
  probe.style.color = `var(${variable})`;
  host.appendChild(probe);
  const channels = getComputedStyle(probe).color.match(/[\d.]+/g) ?? ['0', '0', '0'];
  probe.remove();
  return (
    '#' +
    channels
      .slice(0, 3)
      .map((channel) => Math.round(Number(channel)).toString(16).padStart(2, '0'))
      .join('')
  );
}
